import { createRowMenu } from "../lib/create-row-menu.js";

export function rowMenuInit() {
    const $headerNavigation = document.querySelector(".site-header__navigation-list");
    const headerRowMenu = createRowMenu($headerNavigation, {
        maxWidth: "800px"
    });
}